<template>
  <div class="container">
    <el-row class="title header">
      <h3 class="main-title">回测数据归属: {{canteen.canteen_name}} {{tsToDate}}</h3>
    </el-row>
    <el-row :gutter="10" v-if="currentDishModel">
      <el-row :gutter="5" class="class-dish">
        <el-col :span="12">
          <el-card v-if="currentDishModel" class="box-card">
            <div slot="header" class="clearfix">
              <h3 class="header-title">
                第<span class="danger-text">{{currentIndex + 1}}</span><span>/{{`${dishModelCount}`}}个碗</span>
                名称:
                {{
                  currentDishModel && currentDishModel.dish_name
                    ? currentDishModel.dish_name
                    : "暂无名称"
                }}
              </h3>
              <span class="tag-wrapper" v-if="currentClassImages.length > 0"></span>
              <!--<el-tag v-else type="danger">无碗碟</el-tag>-->
              <div class="btn-wrapper-1">
                <span>
                  <el-button
                    type="primary"
                    :disabled="currentIndex < 1"
                    @click="preDishModel"
                    size="mini"
                    >上一个</el-button
                  >
                  <el-button
                    type="primary"
                    :disabled="currentIndex === dishModelCount - 1"
                    @click="nextDishModel"
                    size="mini"
                    >下一个
                  </el-button>
                  <el-button
                    type="success"
                    class="btn-alone"
                    @click="checkFinished"
                    size="mini"
                    >纠错结束</el-button
                  >
                </span>
              </div>
            </div>
            <!--<div class="image-wrapper"ß>-->
              <!--<img-->
                <!--:src="currentDishModel.dish_image_url"-->
                <!--class="image-item"-->
                <!--alt=""-->
              <!--/>-->
            <!--</div>-->
            <classDishWrapper class="class-dish-wrapper" :image="currentDishModel"></classDishWrapper>
            <h3 class="tip" :class="currentDishModel.dish_type === '1' ? 'primary-text' : 'danger-text'">
                  此碗是
                  <span v-if="currentDishModel.dish_type === '1'" class="danger-text">碗碟识别模式</span>
                  <span v-else class="primary-text">内容识别模式</span>,
                  请重点检查
                  <span v-if="currentDishModel.dish_type === '1'" class="danger-text">碗碟</span>
                  <span v-else class="primary-text">内容</span>,和实例中的是否相符!!!
              </h3>
          </el-card>
          <span v-else>暂无例图!</span>
        </el-col>
        <el-col :span="6">
          <el-card class="delete-card" :body-style="{height: '150px', 'overflow-y': 'scroll'}">
            <div slot="header" class="clearfix">
              <h3 class="header-title danger-text">回收站 <el-badge class="mark" :value="deletedImages.length || 0"/></h3>
            </div>
            <div class="image-wrapper">
              <div
                class="image-item-wrapper"
                v-for="dish in deletedImages"
                :key="dish.dish_img_uuid">
                <el-popover
                  popper-class="big-img"
                  ref="popover2"
                  placement="top-start"
                  trigger="hover"
                >
                  <img
                    :src="dish.dish_img_url"
                    class="image-item"
                    slot="reference"
                    alt=""
                    width="20px"
                    height="20px"
                  />
                  <div class="big-img-wrapper">
                    <el-button
                      type="primary"
                      class="btn"
                      size="mini"
                      style="position: absolute"
                      @click="unDelete(dish)">撤回</el-button>
                    <img :src="dish.dish_img_url" width="150px" alt="" />
                  </div>
                </el-popover>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <h2 class="process-title">
        <!-- // 自查 -->
        <span
          >检查下列图片,如果和上面的例图<span class="strong-text">不相符</span
          >,请点击 图片上的<i class="el-icon-delete danger-text"></i
          >将图片置为纠错状态</span>
        <el-badge class="mark" :value="currentClassImagesLeft.length || 0"/>
        <!-- 审查 -->
      </h2>
      <imageMarkWrapperforDeceted
        v-if="currentClassImages.length > 0"
        :images="currentClassImagesLeft"
        :current_class_id="currentDishModel.class_id"
        @pageChange="pageChange"
        @delete="handleDelete"
      >
      </imageMarkWrapperforDeceted>
      <h3 class="tip-wrapper" v-else>
        当前例图暂无图片
        <el-button
          size="mini"
          type="primary"
          :disabled="currentIndex < 1"
          @click="preDishModel"
          >上一个</el-button>
        <el-button
          size="mini"
          type="primary"
          :disabled="currentIndex === dishModelCount - 1"
          @click="nextDishModel"
          >下一个</el-button>
      </h3>
    </el-row >
    <el-row :gutter="10" v-else>
      <span>小图获取失败</span>
    </el-row>
  </div>
</template>
<script>
import {mapGetters, mapMutations} from 'vuex';
import {apiBackDataMark, apiGetBackData, apiGetClassDishByClassId, apiQueryCanteenClassList} from '@/api';
import imageMarkWrapperforDeceted from '_c/imageMarkWrapperforDeceted';
import classDishWrapper from '_c/classDishWrapper';

import moment from 'moment';

export default {
  name: 'backDataCheck',
  components: {
    imageMarkWrapperforDeceted,
    classDishWrapper
  },
  data () {
    const validatePass = (rule, value, callback) => {
      console.log(`ssssssssssssssss`, value);
      if (value === '') {
        callback(new Error('请输出审查意见'));
      } else {
        callback();
      }
    };
    return {
      classDishList: [],
      modelList2: [],
      currentIndex: 0,
      checkFailReasonShow: false,
      checkFailReason: '',
      backData: {},
      isLastPage: false,
      deletedImages: []
    };
  },
  mounted () {
    this.setSubTitle('回测数据');
    this.getModelList();
    this.getBackImages();
  },
  methods: {
    ...mapMutations([
      'emitLoading',
      'removeLoading',
      'setSubTitle',
      'setAllImageList'
    ]),
    saveCurrentImages () {
      let currentObj = this.backData[this.currentDishModel.class_id];
      try {
        if (currentObj.hasOwnProperty('currentImages')) {
          currentObj.currentImages = this.currentClassImagesLeft;
        } else {
          this.$set(currentObj, 'currentImages', this.currentClassImagesLeft);
        }
      } catch (e) {
        this.$message.error('失败');
        console.log(e);
      }
    },
    back () {
      this.$router.push({
        name: 'taskAdmin'
      });
    },
    async getModelList () {
      try {
        let res = await apiQueryCanteenClassList({ canteenId: this.canteen.canteen_id, apiKey: this.apiKey });
        console.log(res.dish_info_list);
        this.modelList2 = res.dish_info_list;
      } catch (e) {
        console.log(e);
      };
    },
    async checkFinished () {
      if (this.currentIndex !== this.modelList.length - 1) {
        return this.$message.error('只能在最后一个碗碟才能纠错结束');
      }
      this.saveCurrentImages();
      try {
        // 保存;
        if (this.deletedImages.length > 0) {
          this.$store.commit('setAllImageList', this.allImageList);
          this.$router.push({
            name: 'backDataImageMark',
            params: {
              backData: this.$_.cloneDeep(this.backData),
              imageList: this.deletedImages,
              checkedClassList: Object.keys(this.backData),
              modelList: this.modelList2,
              canteen: this.canteen,
              dateRange: this.dateRange
            }
          });
        } else {
          try {
            await apiBackDataMark(
              [],
              this.apiKey,
              Object.keys(this.backData),
              this.allImageList,
              false,
              this.taskUuid
            );
          } catch (e) {
            console.log(e);
            this.$message.error('审查失败');
          }
          if (this.userGroup > 499) {
            this.$router.push({
              name: 'backDataAccByCanteen',
              params: {
                canteen: this.canteen,
                dateRange: this.dateRange
              }
            });
          } else {
            this.back();
          }
        }
        this.removeLoading(500);
      } catch (e) {
        console.log(e);
      }
    },
    handleDelete (dish_img_uuid) {
      let dish = this.$_.find(this.currentClassImages, (a) => {
        return a.dish_img_uuid === dish_img_uuid;
      });
      // this.$set(dish, 'class_id', -1);
      this.deletedImages.push(dish);
    },
    pageChange (page, isLastPage) {
      this.isLastPage = isLastPage;
    },
    async getBackImages () {
      this.currentIndex = 0;
      this.emitLoading();
      try {
        let res = await apiGetBackData({
          canteenId: this.canteen.canteen_id,
          dateRange: this.dateRange,
          username: this.username,
          label_task_uuid: this.taskUuid
        });
        this.backData = res;
        this.deletedImages = [];
        let modelList = await apiGetClassDishByClassId(Object.keys(res));
        this.classDishList = modelList.class_admin_list;
        this.removeLoading();
      } catch (e) {
        this.removeLoading();
        this.$message.error(e.message);
      }
    },
    unDelete (dish) {
      // this.unMark({ dish_img_uuid: dish.dish_img_uuid });
      // this.$set(dish, 'class_id', this.currentDishModel.class_id);
      let idx = this.$_.findIndex(this.deletedImages, (a) => {
        return a.dish_img_uuid === dish.dish_img_uuid;
      });
      if (idx !== -1) {
        this.deletedImages.splice(idx, 1);
      }
    },
    nextDishModel () {
      this.saveCurrentImages();
      if (this.currentIndex < this.modelList.length) {
        this.currentIndex++;
      }
    },
    // 上一个例图
    preDishModel () {
      this.saveCurrentImages();
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    }
  },
  computed: {
    ...mapGetters([
      'markedImageList',
      'listQuery',
      'userinfo',
      'taskUuid'
    ]),
    username () {
      return this.userinfo().username;
    },
    filterWrapperShow () {
      return !this.$route.params.canteen;
    },
    canteen () {
      let {canteen_name, canteen_id} = this.$route.params.checkInfo;
      return {canteen_name, canteen_id};
    },
    // },check
    allImageList () {
      let arr = Object.values(this.backData);
      arr = arr.map(a => a.marked_img_info);
      arr = this.$_.flatten(arr).map(a => a.dish_img_uuid);
      return arr;
    },
    dateRange () {
      let ts = this.$route.params.checkInfo.day_ts;
      return {
        start_ts: ts,
        end_ts: ts + 24 * 3600
      };
    },
    modelList1 () {
      return this.$store.getters.modelList;
    },
    modelList () {
      // let keys = Object.keys(this.backData);
      // if (this.filterWrapperShow) {
      //   return this.$_.intersectionWith(this.modelList1, keys, (leftVal, rightVal) => {
      //     return leftVal.class_id === rightVal;
      //   });
      // } else {
      //   return this.$_.intersectionWith(this.modelList2, keys, (leftVal, rightVal) => {
      //     return leftVal.class_id === rightVal;
      //   });
      // }
      // let res = this.$_.intersectionWith(this.modelList2, this.classDishList, (left, right) => {
      //   return left.class_id === right.class_id;
      // });
      // let res = this.classDishList;
      // res.forEach(a => {
      //   if (!a.dish_name) {
      //     a.dish_name = a.dish_native_name + '(碗碟库)';
      //   }
      // });
      // return res;
      // this.classDishList;
      let classDishList = this.classDishList;
      classDishList.forEach(a => {
        let res = this.$_.find(this.modelList2, dish => dish.class_id === a.class_id);
        console.log(res);
        if (res) {
          this.$set(a, 'dish_name', res.dish_name);
        }
      });
      return this.classDishList;
    },
    // 有回测图片的准确率,
    currentClassImages () {
      if (this.currentDishModel) {
        return this.backData[this.currentDishModel.class_id] &&
          this.backData[this.currentDishModel.class_id].marked_img_info
          ? this.backData[this.currentDishModel.class_id].marked_img_info
          : [];
      } else {
        return [];
      }
    },
    currentClassImagesLeft () {
      return this.$_.differenceBy(this.currentClassImages, this.deletedImages);
    },
    apiKey () {
      return this.userinfo().api_key;
    },
    userGroup () {
      return this.userinfo().userGroup;
    },
    markedCount () {
      return this.$store.state.markedCount[this.currentDishModel.class_id] || 0;
    },
    dishModelCount () {
      return this.modelList.length || 0;
    },
    currentDishModel () {
      return this.modelList[this.currentIndex] || '';
    },
    batchImagesBlongCurrentModel () {
      return this.markedImageList.filter(image => {
        return image.class_id === this.currentDishModel.class_id;
      });
    },
    tsToDate () {
      return moment(this.dateRange.start_ts * 1000).format('YYYY年MM月DD日');
    }
  },
  watch: {
    listQuery: {
      handler () {
        this.getBackImages();
      },
      deep: true
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  .title {
    top: -45px
  }
  .main-title {
    padding: 10px 0;
  }
  .tip-wrapper {
    display: inline-block;
    width: auto;
    padding: 20px;
    border: 2px solid red;
    border-radius: 20px;
  }
  .tip {
    display: inline-block;
    vertical-align: top;
    height: 50px;
    line-height: 50px;
  }
  .unMarked-card {
    height: 100%;
  }
  .header-title {
    display: inline-block;
  }
  .box-card {
    .btn-wrapper-1 {
      display: inline-block;
      margin-top: -10px;
      float: right;
    }
  }
  .btn-wrapper {
    padding-top: 50px;
    width: 80%;
    .btn-wrapper-1 {
      display: inline-block;
      margin-top: -10px;
      float: right;
    }
  }
  .class-dish-wrapper {
    display: inline-block;
    width: 150px;
    height: 150px;
  }
  .image-wrapper {
    display: inline-block;
    width: 100%;
    height: 150px;
    .image-item {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
    }
    .image-item-wrapper {
      display: inline-block;
      width: 20px;
      height: 20px;
      .big-img {
        .big-img-wrapper {
          position: relative;
          .btn {
            position: absolute;
            left: 0;
            top: 0;
          }
        }
      }
    }
  }
  .process-title {
    .strong-text {
      color: #ff0000;
    }
  }
}
</style>
